<template>
  <div class="app">
    <headers class="herderNav" ref="header" :isChange="false" />
    <div class="main" v-html="details"></div>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import headers from "../../components/header.vue";
import searchNav from "../../components/searchNav.vue";
import api from "../../api/aboutGMAT";


export default {
  components: {
    searchNav,
    headers,
  },
  mounted() {
    this.$refs.header.isTop = false;
    this.$refs.header.headerBack.background = "#ffffff";
    this.$refs.header.herderTits.color = "#666666";
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    this.$refs.header.loginButton = {
      background: "#618aff",
      color: "#fff",
    };
    this.$refs.header.phoneButton = {
      color: "#618aff",
      border: "1px solid #618aff",
    };
    // api.baseParams().then(res => {
    //   console.log(res)
    // })
        this.getDetails();
  },
  data() {
    return {
      details: "",
      navCodes: require("@/assets/login/whiteCode.png"),
      headerIcon: require("@/assets/bottom/bottomIcon.png"),
      num: 0,
    };
  },
  methods: {
    getDetails() {
      api.studyGuideeee().then((data) => {
        console.log(data);
        this.details = data.data.data.content;
      });
    },

    goSearch() {
      this.$router.push("/searchMatter");
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    cut() {
      setTimeout(() => {
        if (this.num == 0) {
          this.num = 1;
        } else {
          this.num = 0;
        }
      }, 500);
    },
  },

};
</script>

<style scoped>
@import '../../assets/css/founding.css';
</style>



// WEBPACK FOOTER //
// src/view/founding/founding.vue